import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Tooltip from "@material-ui/core/Tooltip"

const FloatingNumber = styled.div`
  border-radius: 18px;
  min-width: 40px;
  display: inline-block;
  margin: 2px;
  width: 60px;
  height: 26px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
`

const Value = styled.p`
  font-size: 14px;
  font-family: montserratLight;
  color: #fff;
  margin: 0;
  opacity: 0.79;
  font-weight: 500;
`

const BidValue = ({ className, onClick, number, expired }) => {
  let toolTip = true
  let tooltipText
  if (expired === "true") {
    tooltipText = "Winning Bid"
  } else if (className === "goodBid") {
    tooltipText = "Good Bid"
  } 
  // else if (className === "okBid") {
  //   tooltipText = "OK Bid"
  // } 

  else if (className === "okBid") {
    tooltipText = "Good Bid"
  } 
  else if (className === "badBid") {
    tooltipText = "Bad Bid"
  } else {
    toolTip = false
  }
  return toolTip ? (
    <Tooltip title={tooltipText}>
      <FloatingNumber className={className} onClick={onClick}>
        <Value>{number}</Value>
      </FloatingNumber>
    </Tooltip>
  ) : (
    <FloatingNumber className={className} onClick={onClick}>
      <Value>{number}</Value>
    </FloatingNumber>
  )
}

BidValue.defaultProps = {
  className: "inactiveFloatBid",
}

BidValue.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  number: PropTypes.string,
}

export default BidValue



// WEBPACK FOOTER //
// ./src/components/BidValue.js